import React, {useEffect, useState} from 'react';
import { CpIcon } from 'canopy-styleguide!sofe';
import { fetchAsObservable, onPusher } from 'fetcher!sofe';
import { asyncStacktrace, catchSyncStacktrace } from "auto-trace";
import styles from './nav-items.styles.css';
import { track } from 'cp-analytics';
import { debounce } from 'lodash';
import { useHasAccess, useWithUserAndTenant } from 'cp-client-auth!sofe'
const ACCOUNT_STORAGE_KEY = 'cp:communications:inbox:selected-email-account-id'

export const InboxIcon = () => {
  const [user,] = useWithUserAndTenant()
  const [emailUnread, setEmailUnread] = useState(null)
  const [commentsUnread, setCommentsUnread] = useState(null)
  const [emailUnreadChannel, setEmailUnreadChannel] = useState(null)
  const [storedAccountId, setStoredAccountId] = useState(getInboxAccountPreference())
  const hideUnreadCount = user?.preferences?.communications?.navbar_hide_count
  const hasCommentsAccess = useHasAccess(['comments'])

  window.addEventListener('storage', () => {
    const inboxAccountPreference = getInboxAccountPreference()
    if (inboxAccountPreference !== storedAccountId) {
      setStoredAccountId(inboxAccountPreference)
    }
  });

  useEffect(() => {
    if (hasCommentsAccess) {
      const initialCount = fetchAsObservable(`/wg/comments-unread`).subscribe(
        response => setCommentsUnread(response.unread),
        asyncStacktrace(error => {
          error.showToast = false; // No toast on error, this shouldn't be disruptive
          catchSyncStacktrace(error)
        })
      )
      return () => initialCount.unsubscribe()
    }
  }, [hasCommentsAccess])

  useEffect(() => {
    if (hideUnreadCount) return

    const initialCount = fetchAsObservable(`/email-accounts/${storedAccountId || '0'}/unread-count`)
      .subscribe(
        response => {
          setEmailUnreadChannel(response?.channel)
          setEmailUnread(!!response?.count)
        },
        asyncStacktrace(error => {
          if (error.status === 404) {
            removeStoredAccountId()
          }
          error.showToast = false; // No toast on error, this shouldn't be disruptive
          catchSyncStacktrace(error)
        })
      )

    return () => initialCount?.unsubscribe?.()
  }, [storedAccountId])

  useEffect(() => {
    if(emailUnreadChannel && !hideUnreadCount) {
      const emailUnreadPusher = onPusher('inbox', emailUnreadChannel)
        .subscribe(
          response => setEmailUnread(!!response?.unread_count),
          asyncStacktrace(error => {
            error.showToast = false; // No toast on error, this shouldn't be disruptive
            catchSyncStacktrace(error);
          })
        )

      return () => emailUnreadPusher?.unsubscribe?.()
    }
  }, [emailUnreadChannel])

  useEffect(() => {
    if (hasCommentsAccess) {
      const commentsUnreadPusher = onPusher('comments-unread')
        .subscribe(
          response => setCommentsUnread(response?.unread),
          asyncStacktrace(error => {
            error.showToast = false; // No toast on error, this shouldn't be disruptive
            catchSyncStacktrace(error);
          })
        )
      return () => commentsUnreadPusher?.unsubscribe?.()
    }
  }, [hasCommentsAccess])

  const unread = !hideUnreadCount && (emailUnread || commentsUnread)

  return (
    <a href='/#/inbox' onClick={trackInboxNavigation} className={styles.inboxContainer}>
      <div className={styles.navLink}>
        <div className={styles.inboxButton}>
          <CpIcon name={'communication-envelope'} fill='var(--cp-color-primary-nav-button-icon)'/>
          {unread && (
            <div className={styles.notificationWrapper}>
              <div className={styles.notificationCount} />
            </div>
          )}
        </div>
        <span className={styles.navLabel}>Inbox</span>
      </div>
    </a>
  );
};

const getInboxAccountPreference = () => {
  return window.localStorage.getItem(ACCOUNT_STORAGE_KEY)
}

export const removeStoredAccountId = () => {
  window.localStorage.removeItem(ACCOUNT_STORAGE_KEY)
  window.dispatchEvent(new Event('storage'))
}

const trackInboxNavigation = debounce(() => {
  return track('practice_management', 'communications', 'inbox_nav-bar-icon.clicked');
}, 300)
